import { h } from "preact";
import { useState } from "preact/hooks";
import jobData from "./jobData.json";
import universityData from "./universityContData.json";
import additionalData from "./moreExpData.json";
import skillsData from "./skillsData.json";
import appleImage from "../images/at_apple.jpg";
import "./corner_styles.css";
import "./button_styles.css";

function ResumeEntry({ entry, type }) {
  const [isOpen, setOpen] = useState(false);
  const name = entry.companyName || entry.projectName;
  const title = entry.jobTitle || entry.projectTitle;
  const date = entry.jobDates || entry.projectDates;
  const location = entry.jobLocation || entry.projectLocation;
  const details = entry.jobDescription || entry.projectDescription;

  return <article class="resume-entry" data-scroll-reveal>
    <div class="resume-entry-top">
      <div><h3>{name}</h3><p>{title}</p></div>
      <div class="resume-meta">
        <p>{date}</p>
        {location && <p>{location}</p>}
      </div>
    </div>
    <button class="resume-details" onClick={() => setOpen(!isOpen)} aria-expanded={isOpen} aria-label={`${isOpen ? "Hide" : "Show"} details for ${name}`}>{isOpen ? "−" : "+"}</button>
    {isOpen && <ul>{details.map((detail) => <li key={detail}>{detail}</li>)}</ul>}
  </article>;
}

function ResumeSection({ id, title, entries, type }) {
  return <section class="resume-section-new" id={id} data-scroll-reveal>
    <p class="eyebrow">{type}</p>
    <h2>{title}</h2>
    <div class="resume-entries">{entries.map((entry) => <ResumeEntry entry={entry} type={type} key={entry.companyName || entry.projectName} />)}</div>
  </section>;
}

function SkillsSection() {
  return <section class="resume-section-new resume-skills-section" id="skills" data-scroll-reveal>
    <p class="eyebrow">Skills</p>
    <h2>Tools & foundations</h2>
    <div class="resume-skills-grid">
      {skillsData.map((category) => <section class={`resume-skill-group${category.skillCategory === "Software Engineering" ? " resume-skill-group-wide" : ""}`} key={category.skillCategory}>
        <h3>{category.skillCategory}</h3>
        <ul>{category.skillsList.map((skill) => <li key={skill}>{skill}</li>)}</ul>
      </section>)}
    </div>
  </section>;
}

export default function ResumePage() {
  const scrollToSection = (sectionId) => document.getElementById(sectionId).scrollIntoView({ behavior: "smooth", block: "start" });

  return <main class="corner-page resume-page">
    <section class="resume-hero">
      <p class="eyebrow">Resume</p>
      <h1>Experience</h1>
      <p class="page-intro">Software engineer with experience building backend services, full-stack applications, and iOS tools across product-focused engineering teams.</p>
    </section>
    <nav class="resume-jump-links" aria-label="Resume sections">
      <button type="button" class="button-style resume-jump-button" onClick={() => scrollToSection("experience")}>Work experience</button>
      <button type="button" class="button-style resume-jump-button" onClick={() => scrollToSection("university")}>University & leadership</button>
      <button type="button" class="button-style resume-jump-button" onClick={() => scrollToSection("additional")}>Additional experience</button>
      <button type="button" class="button-style resume-jump-button" onClick={() => scrollToSection("skills")}>Skills</button>
    </nav>
    <ResumeSection id="experience" title="Work experience" entries={jobData} type="Professional" />
    <ResumeSection id="university" title="University & leadership" entries={universityData} type="University" />
    <ResumeSection id="additional" title="Additional experience" entries={additionalData} type="Community" />
    <SkillsSection />
    <figure class="resume-photo" data-scroll-photo><img src={appleImage} alt="Apple interns" />
    <figcaption>Me with my Apple intern class, Summer 2023</figcaption>
    </figure>
    
  </main>;
}
